import { AsyncMenuButton } from "src/components/common/contextMenu/AsyncMenuButton.tsx";
import { faFileExport, faPrint } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";
import { ShopOrderBatchPrintApi } from "src/api/generated/erp/production/shopOrderBatch/api/shopOrderBatchPrintApi.ts";
import { WiivakalusteShopOrderBatchApi } from "src/api/generated/tenants/wiivakaluste/production/wiivakalusteShopOrderBatchApi.ts";
import { downloadFile } from "src/utils/fileDownloading.ts";

export const WiivakalusteShopOrderBatchContextMenuComponents = ({
	allSelectedBatchIds,
}: {
	allSelectedBatchIds: number[];
}) => {
	const batchIds = allSelectedBatchIds.filter((id): id is number => id != null);
	return [
		<AsyncMenuButton
			key="printSawList"
			label={i18n.t("saw_list")}
			icon={faPrint}
			disabled={batchIds.length !== 1 ? i18n.t("saw_list_select_exactly_one_batch") : false}
			onClick={async () => {
				const shopOrderBatchId = batchIds[0];
				if (shopOrderBatchId == null) return;

				const fileHandle = await ShopOrderBatchPrintApi.printSawList({
					shopOrderBatchId: shopOrderBatchId,
				});
				downloadFile(fileHandle);
			}}
		/>,
		<AsyncMenuButton
			key="exportSawImportFile"
			label={i18n.t("saw_import_file")}
			icon={faFileExport}
			disabled={batchIds.length === 0 ? i18n.t("saw_import_file_select_at_least_one_batch") : false}
			onClick={async () => {
				const fileHandles = await WiivakalusteShopOrderBatchApi.exportSawImportFile({
					shopOrderBatchIds: batchIds,
				});
				fileHandles.forEach(downloadFile);
			}}
		/>,
	];
};
